import FizConfig from "../FizConfig.js";
import * as Storage from "../lib/Storage.ts";
import $ from "../$.js"

Storage.sessionSet("lang",$('html').attr('lang'));

//launch autologin process if it might works
if(['/index.html','/'].indexOf(window.location.pathname)>-1){
  var
    rememberIdentifier = Storage.localGet("rememberIdentifier"),
    rememberToken = Storage.localGet("rememberToken");
  
  if (window.location.search.indexOf("noautologin")===-1 && window.location.search.indexOf("apidown")===-1 && rememberIdentifier && rememberToken && (rememberIdentifier+rememberToken).length>0){
    window.location="home.php";
  }
}



$('header button,.header button').on('click',function(evt){
  var toogled = $(this).parent().toggleClass('fw-open');
  evt.stopPropagation();
  $(document).one('scroll click',function(){
    toogled.toggleClass('fw-open',!toogled);
  });
  
  
});

$('a.itunelink').each(function(key, a){
  a = $(a);
  if(!a.hasClass('disabled')){
    a.attr('href',FizConfig.IPHONE_DOWNLOAD_URL);  
  }
});
$('a.gplaylink').each(function(key, a){
  a = $(a);
  if(!a.hasClass('disabled')){
    a.attr('href',FizConfig.ANDROID_DOWNLOAD_URL);
  }
});
$('a.downloadlink').each(function(key, a){
  a = $(a);
  if(!a.hasClass('disabled')){
    a.attr('href',FizConfig.API_BASE_URL+'dl')
  }
});

if(Storage.sessionGet('isLoggued')==='true'){
  $('a').each(function(key,a){
    a = $(a);
    if(a.attr('href') && a.attr('href').indexOf('index.html')===0){
      a.attr('href','home.php');
    }
  });
}